<div class="heading-3 bold">{{ 'general.api_sales_selected_tickets' | translate }}</div>
<div class="body-2 text-muted" *ngIf="!getSectorsWithSelectedTickets?.length && !cartService.selectedTicketsMap.selectedTicketTypes?.length">
  <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
  {{ 'general.api_sales_no_tickets_selected' | translate }}
</div>
<app-loader [loading]="ticketTypeService.typesLoading" [overlay]="true"></app-loader>
<ng-container *ngIf="cartService.selectedTicketsMap?.selectedTicketTypes?.length">
  <div class="flex space-between">
    <div class="heading-5 text-base no-margin break-word">
      {{ 'general.api_sales_selected_ticket_types' | translate }}
      <br>
      <div class="body-1 text-grey">{{ (cartService.selectedTicketsMap.event?.quantity || 0) | quantityInPcs }}</div>
    </div>
    <div class="flex">
      <div>
        <button mat-button class="icon-button input-button" (click)="confirmTicketTypesClear()">
          <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
        </button>
      </div>
      <div>
        <button mat-button class="icon-button input-button" (click)="ticketTypesCollapsed = !ticketTypesCollapsed">
          <mat-icon class="svg-icon" [svgIcon]="ticketTypesCollapsed ? 'arrow_up' : 'arrow_down'"></mat-icon>
        </button>
      </div>
    </div>
  </div>
  <table class="selected-tickets-table top-spacer" *ngIf="!ticketTypesCollapsed">
    <tr>
      <th class="max-width">{{ 'general.api_cart_table_type' | translate }}</th>
      <th class="min-width align-right">{{ 'general.api_cart_table_price' | translate }}</th>
      <th class="min-width align-right">{{ 'general.api_cart_table_quantity' | translate }}</th>
      <th class="min-width">&nbsp;</th>
    </tr>
    <ng-container *ngFor="let ticketType of cartService.selectedTicketsMap?.selectedTicketTypes">
      <tr class="ticket-type-row">
        <td class="medium" colspan="4">{{ ticketType.name | translateValue }}</td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td class="white-space-no-wrap align-right price-type-price">{{ ticketType.price | price }}</td>
        <td class="white-space-no-wrap">
          <app-add-remove [alignRight]="true" [count]="ticketTypeService.typeQuantities[ticketType.ticketTypeUuid]" [autoBind]="true"
                          [max]="getTicketTypeMax(ticketType.ticketTypeUuid)"
                          (countChange)="changeTicketTypeCount(ticketType.ticketTypeUuid, $event)"></app-add-remove>
        </td>
        <td>
          <button mat-button class="icon-button input-button small" (click)="removeTicketType(ticketType)">
            <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
          </button>
        </td>
      </tr>
    </ng-container>
  </table>
</ng-container>
<ng-container *ngFor="let sector of getSectorsWithSelectedTickets">
  <div class="flex space-between">
    <div class="heading-5 text-base no-margin break-word">
      {{sector.name | translate}}
      <br>
      <div class="body-1 text-grey">{{(getSectorTickets(sector.id)?.length || 0) | quantityInPcs}}</div>
    </div>
    <div class="flex">
      <div>
        <button mat-button class="icon-button input-button" (click)="confirmSectorClear(sector.id)">
          <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
        </button>
      </div>
      <div>
        <button mat-button class="icon-button input-button" (click)="toggleSelectedTicketSector(sector.id)">
          <mat-icon class="svg-icon" [svgIcon]="expandedSectors.includes(sector.id) ? 'arrow_up' : 'arrow_down'"></mat-icon>
        </button>
      </div>
    </div>
  </div>
  <table class="selected-tickets-table top-spacer" *ngIf="expandedSectors.includes(sector.id)">
    <tr>
      <th class="min-width align-center">{{ 'general.api_cart_table_row' | translate }}</th>
      <th class="min-width align-center">{{ 'general.api_cart_table_seat' | translate }}</th>
      <th class="align-right">{{ 'general.api_cart_table_type' | translate }}</th>
      <th class="align-right max-width">{{ 'general.api_cart_table_price' | translate }}</th>
    </tr>
    <ng-container *ngFor="let priceZone of getPriceZonesWithSelectedTickets(sector.id)">
      <tr class="price-zone-row">
        <td class="break-word align-right medium" [colSpan]="4" [ngStyle]="{'color': sector.hasSeats ? priceZone.color : ''}" [ngClass]="{'text-base': !sector.hasSeats}">
          {{(sector.hasSeats ? 'general.api_sales_selected_price_zone' : 'general.api_sales_selected_standing_places') | translate}}
          <mat-icon *ngIf="sector.hasSeats" class="svg-icon" [svgIcon]="'circle_filled'"></mat-icon>
          <br>
          <small class="text-muted" *ngIf="!sector.hasSeats">{{'general.api_general_id' | translate}}: {{priceZone.id}}</small>
        </td>
      </tr>
      <ng-container *ngFor="let ticket of getSectorPriceZoneTickets(sector.id, priceZone.id)">
        <tr>
          <td class="align-center">{{ticket.row || '-'}}</td>
          <td class="align-center">{{ticket.place || '-'}}</td>
          <td class="white-space-no-wrap align-right price-type-price" colspan="2"><b>{{ ticket | ticketPrice }}</b></td>
        </tr>
        <tr class="price-type-row">
          <td class="break-word max-width align-right" [colSpan]="3">
            <ng-container *ngIf="getAvailableTicketPrices(ticket).length > 1">
              <mat-form-field appearance="outline" class="small no-hint">
                <mat-select [(ngModel)]="ticket.priceTypeId" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="cartService.updateTicketPriceType(cartService.selectedTicketsMap.event.id, ticket)">
                  <mat-option *ngFor="let priceType of getAvailableTicketPrices(ticket)" [value]="priceType.id">
                    {{priceType.name | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="getAvailableTicketPrices(ticket).length <= 1">
              {{ ticket.priceTypeName | translate }}
            </ng-container>
          </td>
          <td class="min-width align-right">
            <button mat-button class="icon-button input-button small" (click)="removeSeats.emit([ticket])">
              <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
            </button>
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </table>
  <hr class="slim">
</ng-container>
